import { taskApi } from 'api';

export const createTaskAttachment = async (taskId: string, serviceAgreementUid: string, file: File) => {
  return await taskApi.createTaskAttachment({ serviceAgreementUid, taskUid: taskId, file });
};
